module.exports = __webpack_public_path__ + "static/img/solutionDetailPic13.c8832e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic13.jpg
// module id = VAbN
// module chunks = 1